// Lib
import { classicFormatMaxTwoDigits } from '@/utils/hooks/format/useFormatNumber';

// Types
import type { ChartType } from '@/lib/analytics/charts/type';
import { SIZE_FULL } from '@/lib/gridElements/size';
import { FACEBOOK } from '@/lib/socialProfile';

// Components
import { BarGroupedChart } from '@/components/composite/Charts/BarGroupedChart';

export const postHistoryConfig: ChartType<typeof BarGroupedChart> = {
    title: 'chart.facebook.post_history',
    tooltip: 'chart.facebook.post_history_tooltip',
    id: 'posts_history',
    margin: { left: -30, bottom: 25, right: 10 },
    name: {
        date: 'date',
        value: 'chart.facebook.post_history_name'
    },
    social: FACEBOOK,
    color: {
        value: 'blue'
    },
    valueFormat: classicFormatMaxTwoDigits,
    isXAxisDate: true,
    size: SIZE_FULL,
    type: 'chart',
    element: BarGroupedChart
};
